import React, { useEffect, useRef, useState } from "react";
import { DashboardLayout } from "../../../Layouts/Dashboard/Index";
import QrScanner from "qr-scanner";
import {
  getParticipantById,
  getParticipantByIdForRoom,
  updateRoomDetails,
} from "../../../hooks/useAddRoomParticipants";
import { ParticipantsList, RoomDetailsType } from "../../../types/common";
import MyModal from "../../../Components/Modal";
import LoadingState from "../../../Components/Loading";
import moment from "moment";
import SuccessAudio from "../../../assets/audio/success.mp3";
import WarningAud from "../../../assets/audio/warning.mp3";

import WelcomeBgv from "../../../assets/video/background.mp4";
import SuccessBgv from "../../../assets/video/success.mp4";
import QrFrame from "../../../assets/qrframe.png";
import Nholder from "../../../assets/nameholder.png";
import { getDay } from "../../../utils/dateUtils";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

const ScanRoomQrPage = ({ room = 0 }) => {
  const [refresh, setRefresh] = useState(false);
  // useEffect(() => {
  //   alert("ScanRoomQrPage title: " + title);
  // }, [title]);
  var WelcomeBg = WelcomeBgv;
  var SuccessBg = SuccessBgv;
  const [loading, setLoading] = useState(false);
  let roomName;

  const [qrData, setQrData] = useState<string | undefined>();

  const [participant, setParticipant] = useState<
    ParticipantsList | null | undefined
  >(null);
  const [attemptSequence, setAttemptSequence] = useState<number>(0);
  const [message, setMessage] = useState<{ success: boolean; message: string }>(
    { success: false, message: "" }
  );
  const [isClockedIn, setIsClockedIn] = useState<boolean>(false);

  const [open, setOpen] = useState(false);

  const [openError, setOpenError] = useState(false);

  const video = useRef<HTMLVideoElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const welcomeVideoRef = useRef<HTMLVideoElement>(null);
  const successVideoRef = useRef<HTMLVideoElement>(null);

  const [qrScanner, setQrScanner] = useState<QrScanner>();
  const [show, setShow] = useState(false);

  async function close() {
    qrScanner?.destroy();
    setQrScanner(undefined);
  }

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.currentTime = 5;
      videoElement.play();
    }
  }, [participant]);

  useEffect(() => {
    const welcomeVideo = welcomeVideoRef.current;
    const successVideo = successVideoRef.current;

    if (welcomeVideo) {
      welcomeVideo.play().catch((err) => {
        console.error("Error playing welcome video:", err);
      });
    }

    if (successVideo) {
      successVideo.load();
    }
  }, []);

  useEffect(() => {
    if (video.current) {
      const qrScanner = new QrScanner(
        video.current,
        (result) => handleScan(result),
        {
          highlightScanRegion: true,
        }
      );
      qrScanner.setGrayscaleWeights(76, 153, 25, true);
      qrScanner
        .start()
        .then(() => {
          setQrScanner(qrScanner);
        })
        .catch((err) => {
          console.error(
            "Camera permission denied or another error occurred:",
            err
          );
          // Handle the case where permission is denied
          alert(
            "Camera access is required to scan the QR code. Please enable camera permissions in your browser."
          );
          // Optionally, you can display a UI message instead of an alert
        });

      return () => {
        qrScanner.stop();
        qrScanner.destroy();
        setQrScanner(undefined);
      };
    }
  }, []);

  function handleScan(result: QrScanner.ScanResult) {
    setQrData(result.data);
    qrScanner?.destroy();
    setQrScanner(undefined);
  }

  function getRoomName(room: number): string {
    switch (room) {
      case 1:
        return "Room 1";
      case 2:
        return "Room 2";
      case 3:
        return "Room 3";
      default:
        return "Unknown Room";
    }
  }

  const getUserDetails = async (data: string) => {
    setLoading(true);
    await getParticipantByIdForRoom(data)
      .then(async (res) => {
        if (res?.success) {
          const participant = res.data as ParticipantsList | null;
          console.log("Participant data fetched:", participant);
          if (participant !== null && participant !== undefined) {
            if (getDay() === 1) {
              if (
                participant?.clockedInDayOne !== undefined &&
                participant?.clockedInDayOne !== null
              ) {
                setParticipant(participant);

                let roomDetails: RoomDetailsType = {
                  id: data,
                  roomNo: room,
                  isCheckedIn: true,
                  clockedIn: new Date().toString(),
                  day: getDay(),
                };
                await updateRoomDetails(
                  roomDetails,
                  data,
                  room,
                  getDay(),
                  participant
                )
                  .then((attemptSeq) => {
                    console.log(
                      "Room check-in successful with attemptSeq:",
                      attemptSeq
                    );
                    setAttemptSequence(attemptSeq);
                  })
                  .catch((e) => {
                    console.error("Error updating room details:", e);
                  });
                setTimeout(() => {
                  setShow(true);
                }, 4000);
                if (successVideoRef.current) {
                  successVideoRef.current.currentTime = 5;
                  successVideoRef.current.play();
                }
                const successAudio = new Audio(SuccessAudio);
                successAudio.play().catch((err) => {
                  console.error("Success audio failed to play:", err);
                });
                setTimeout(() => {
                  setShow(false);
                  setOpen(false);
                  setParticipant(null);
                  setQrData(undefined);
                }, 10000);
              } else {
                setMessage({
                  success: false,
                  message:
                    "Please scan your qr at main entrance before entering the room",
                });
                setOpen(true);
                setTimeout(() => {
                  setShow(false);
                  setOpen(false);
                  setParticipant(null);
                  setQrData(undefined);
                }, 5000);
              }
            } else if (getDay() === 2) {
              if (
                participant?.clockedInDayTwo !== undefined &&
                participant?.clockedInDayTwo !== null
              ) {
                setParticipant(participant);

                let roomDetails: RoomDetailsType = {
                  id: data,
                  roomNo: room,
                  isCheckedIn: true,
                  clockedIn: new Date().toISOString(),
                  day: getDay(),
                };
                await updateRoomDetails(
                  roomDetails,
                  data,
                  room,
                  getDay(),
                  participant
                )
                  .then((attemptSeq) => {
                    console.log(
                      "Room check-in successful with attemptSeq:",
                      attemptSeq
                    );
                    setAttemptSequence(attemptSeq);
                  })
                  .catch((e) => {
                    console.error("Error updating room details:", e);
                  });
                setTimeout(() => {
                  setShow(true);
                }, 4000);
                if (successVideoRef.current) {
                  successVideoRef.current.currentTime = 5;
                  successVideoRef.current.play();
                }
                const successAudio = new Audio(SuccessAudio);
                successAudio.play().catch((err) => {
                  console.error("Success audio failed to play:", err);
                });
                setTimeout(() => {
                  setShow(false);
                  setOpen(false);
                  setParticipant(null);
                  setQrData(undefined);
                }, 10000);
              } else {
                setMessage({
                  success: false,
                  message:
                    "Please scan your qr at main entrance before entering the room",
                });
                setOpen(true);
                setTimeout(() => {
                  setShow(false);
                  setOpen(false);
                  setParticipant(null);
                  setQrData(undefined);
                }, 5000);
              }
            } else {
              setMessage({
                success: false,
                message: "Event is not active today",
              });
              setOpen(true);
            }
          }
        } else {
          setMessage({
            success: false,
            message: "There is no participant with that ID",
          });
          setOpen(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (qrData) {
      setOpen(false);
      setShow(false);
      setParticipant(null);
      setMessage({ success: false, message: "" });
      getUserDetails(qrData);
    }
  }, [qrData]);

  const getClockinDate = (date: any) => {
    if (!date) return "Not Clocked In";
    return moment(new Date(date.seconds * 1000)).format(
      "YYYY/MM/DD - hh : mm A"
    );
  };

  function calculateBottomPosition(screenHeight: number) {
    const minScreenHeight = 616;
    const maxScreenHeight = 832;
    const minBottom = 86;
    const maxBottom = 140;

    // Calculate the ratio of the screen height to the range
    const ratio =
      (screenHeight - minScreenHeight) / (maxScreenHeight - minScreenHeight);

    // Apply the ratio to the bottom value range
    const bottomPosition = minBottom + ratio * (maxBottom - minBottom);

    return bottomPosition;
  }

  const bottom = calculateBottomPosition(useWindowDimensions().height);
  return (
    <DashboardLayout isHidden={true}>
      {/* {loading && <LoadingState />} */}
      {/* <audio src={require("./src/assets/audio/success.mp3")}></audio> */}
      <MyModal isOpen={loading} setIsOpen={setLoading} isTransparent>
        <div className="text-center ava-meridian-text">
          <div className="text-4xl pt-3 pb-5 text-white whitespace-nowrap animate-pulse">
            LOADING . . .
          </div>
        </div>
      </MyModal>

      <MyModal isOpen={open} setIsOpen={setOpen}>
        <div className="text-center w-[300px]">
          <div className="py-4">
            <p
              className={`${
                message.success ? "text-green-500" : "text-red-500"
              }`}
            >
              {message.message}
            </p>
          </div>
          <div className="flex justify-center">
            <button
              onClick={() => {
                setOpen(false);

                setQrData(undefined);
              }}
              className={`focus:outline-none text-white ${
                message.success
                  ? "bg-green-700 hover:bg-green-800"
                  : "bg-red-500 hover:bg-red-800"
              } font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2`}
            >
              Closes
            </button>
          </div>
        </div>
      </MyModal>
      <div className="pt-16 h-full w-full relative">
        <video
          ref={welcomeVideoRef}
          src={WelcomeBg}
          loop
          muted
          className="absolute top-0 left-0 w-full h-full object-fill"
        />

        <video
          ref={successVideoRef}
          src={SuccessBg}
          muted
          className="absolute top-0 left-0 w-full h-full object-fill"
          style={{ display: participant ? "block" : "none" }}
        />

        <div className="flex h-full relative">
          <div
            className="relative h-[78%] w-[36%] mt-2 ml-[7%]"
            style={{
              backgroundImage: `url(${QrFrame})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
            }}
          >
            <video
              ref={video}
              className="w-full h-full"
              style={{
                scale: "88%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: 0,
                overflow: "hidden",
                paddingRight: "30px",
                paddingLeft: "30px",
                paddingTop: "20px",
                paddingBottom: "20px",
              }}
            ></video>
          </div>
          <div
            className={`w-full relative pt-[54vh] ava-meridian-text text-white transition-opacity ease-in ${
              show ? "duration-1000 opacity-100" : "duration-0 opacity-0"
            }`}
          >
            <div
              className="pt-2 text-center w-full uppercase tracking-widest"
              style={{
                letterSpacing: 4,
                fontSize: "3vw",
                color: "rgb(0, 64, 105)",
                textShadow: "1px 1px 3px rgba(0,0,0,0.2)",
                fontFamily: "'Arial', sans-serif",
              }}
            >
              {getRoomName(room)}
            </div>
            <div
              className="pt-2 text-center w-full font-bold uppercase"
              style={{
                letterSpacing: 4,
                fontSize: "3vw",
                color: "rgb(0, 64, 105) ",
                textShadow: "1px 1px 3px rgba(0,0,0,0.2) ",
              }}
            >
              {attemptSequence % 2 === 1 ? "Welcome!" : "Thank you!"}
            </div>
            <div
              className={`text-center w-full`}
              style={{
                bottom: bottom,
                backgroundImage: `url(${Nholder})`,
              }}
            >
              <div
                className="pt-2"
                style={{ letterSpacing: 2, fontSize: "2vw" }}
              >
                {participant?.name}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ScanRoomQrPage;
